import type { CitizenAsset } from './citizenAsset';

/** Which of the citizens' figures plays whom: one of the figures of a trade. */
export interface Casting {
  /** The figure, as its place among the asset's, that member `who` of a trade is drawn with. */
  figureOf(trade: number, who: number): number;
  /** The figures a trade is drawn with. */
  figuresOf(trade: number): readonly number[];
}

/* Knuth's multiplier: neighbours in number are far apart in figure. The top of the product is
   used, as its low bits repeat for a pool of three. */
const SPREAD = 2654435761;

/**
 * Gives each trade its figures, named ones among them. Throws where a trade has none, naming it:
 * a trade nobody can play is a mistake in the trades or in the wardrobe.
 */
export function castTrades(asset: CitizenAsset, trades: readonly string[]): Casting {
  const pools = trades.map((trade) => {
    const pool = asset.figures.flatMap((figure, i) => (figure.trade === trade ? [i] : []));
    if (pool.length === 0) throw new Error(`citizens: no figure of the trade ${trade}`);
    return pool;
  });
  return {
    figureOf: (trade, who) => {
      const pool = pools[trade]!;
      return pool[Math.floor(((Math.imul(who + 1, SPREAD) >>> 0) / 2 ** 32) * pool.length)]!;
    },
    figuresOf: (trade) => pools[trade]!,
  };
}
